import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const BroadmeadowsCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Broadmeadows" suburbSlug="broadmeadows" variant="cdbs-dentist" />
);

export default BroadmeadowsCdbsDentistPage;
